export default __webpack_public_path__ + "static/media/moti.5f1ef10b.png";